import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import GenericFormContainer from './FormContainer';

import ChatBot from './Chatbot';
function ContactForm(){
    return (
        <> 
            <GenericFormContainer>

                <Row className="">
                    
                    <Col>
                        <h1 className="text-font-body text-font-size-large text-font-medium text-start">Contact Sunset</h1>
                    </Col>
                </Row>
                <Row className="">
                    <Col>
                        <form>
                        <div className="mb-3 brand-tertiary-color-border">
                            <input placeholder="Enter your name..." type="email" className="border-0 input-fill no-generic-input-styles" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        </div>
                        <div className="mb-3 brand-tertiary-color-border">
                            <input placeholder="Enter your email address..." type="email" className="border-0 input-fill no-generic-input-styles" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        </div>
                        <div className="mb-3">
                            <textarea placeholder="Your Message" className="form-control no-resize" id="exampleInputPassword1" rows={5} />
                        </div>
                        <button type="button" className="btn btn-secondary w-100">Send</button>
                        </form>
                    </Col>
                </Row>

            </GenericFormContainer>
            <Row>
                <ChatBot />
            </Row>

        </>
    )
}

export default ContactForm;